<div class="tag" [ngClass]="typeArray[type] + ' ' + class">
  @if (withIcon && iconName) {
  <div class="icon">
    <svg-icon

      [stretch]="true"
      [src]="'assets/icons/' + iconName + '.svg'"
      [svgStyle]="{
        'width.px': width ? width : '14',
        'height.px': height ? height : '14'
      }"
    >
    </svg-icon>
  </div>
  }
  <div>{{ label }}</div>
</div>
